require('highlight');
import hljs from 'highlight.js';

document.querySelectorAll('pre').forEach((block) => {
  hljs.highlightBlock(block);
})